import { Component, OnInit } from "@angular/core";
import { ModalService } from "@core-services/modal.service";
import { FiatDepositModalComponent } from "@modules/main/components/step-summary/fiat-transactions/fiat-deposit-modal/fiat-deposit-modal.component";
import { FiatTransaction } from "@models/transaction";

@Component({
	selector: "deposit-dialog",
	template: "",
	standalone: false
})
export class DepositDialogComponent implements OnInit {
	constructor(private modalService: ModalService) {}

	public ngOnInit(): void {
		this.modalService
			.create(
				FiatDepositModalComponent,
				{ data: { transaction: new FiatTransaction() } },
				{ showCloseButton: false }
			)
			.present();
	}
}
